// Tag entity types
export enum TagEntityType {
	PART = 'PART',
}

// Tag type definition
export type Tag = {
	id: number;
	label: string;
	color: string;
	associatedPartsCount?: number;
};

// Flatfile dropdown option shape for tags
export type TagOption = {
	label: string;
	value: string;
};

// Request/Response types
export type CreateTagRequest = {
	label: string;
	color: string;
};

export type UpdateTagRequest = {
	label?: string;
	color?: string;
};
